import { render, staticRenderFns } from "./DataSourceSelection.vue?vue&type=template&id=0e8a0990&scoped=true"
import script from "./DataSourceSelection.vue?vue&type=script&lang=js"
export * from "./DataSourceSelection.vue?vue&type=script&lang=js"
import style0 from "./DataSourceSelection.vue?vue&type=style&index=0&id=0e8a0990&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8a0990",
  null
  
)

export default component.exports